import type { TFunction } from 'i18next';
import type { OptimizerRunV2PortfolioSummary } from '../../types/run.types';

export const formatRunOutcome = (
  t: TFunction,
  summary: OptimizerRunV2PortfolioSummary | null | undefined,
): string => {
  if (!summary || summary.total === 0) {
    return t('outcome.none');
  }

  const parts: string[] = [];

  if (summary.succeeded > 0) {
    parts.push(t('outcome.rebalanced', { count: summary.succeeded }));
  }

  if (summary.failed > 0) {
    parts.push(t('outcome.failed', { count: summary.failed }));
  }

  if (summary.skipped > 0) {
    parts.push(t('outcome.skipped', { count: summary.skipped }));
  }

  return parts.length > 0 ? parts.join(' · ') : t('outcome.none');
};

export const formatRunProgressOutcome = (
  t: TFunction,
  summary: OptimizerRunV2PortfolioSummary | null | undefined,
): string => {
  if (!summary || summary.total === 0) {
    return t('outcome.processing');
  }

  const processed = summary.succeeded + summary.failed + summary.skipped;

  if (processed === 0) {
    return t('outcome.processingTotal', { total: summary.total });
  }

  return t('outcome.processingProgress', {
    processed,
    total: summary.total,
  });
};
